import { generateGuid } from '../../../../utils/typedHelper';

export interface DocumentSection {
    id: string;
    name: string;
    isLetterSection: boolean;
    isLoiSection: boolean;
    index: number;
    isAvailableForBuyers: boolean;
    isAvailableForSellers: boolean;
    // [#1301] A Pre-suspension Archive section: made by a resume, read-only for every client.
    isArchive: boolean;
}

export const EngagementAgreementSectionName = 'Engagement Agreements';

export const GenerateDocumentSectionList = (): DocumentSection[] => [
    {
        id: generateGuid(),
        name: EngagementAgreementSectionName,
        isLetterSection: true,
        isLoiSection: false,
        index: 1,
        isAvailableForBuyers: false,
        isAvailableForSellers: true,
        isArchive: false,
    },
    {
        id: generateGuid(),
        name: 'ID NDAs',
        isLetterSection: false,
        isLoiSection: false,
        index: 2,
        isAvailableForBuyers: true,
        isAvailableForSellers: true,
        isArchive: false,
    },
    {
        id: generateGuid(),
        name: 'Data NDAs',
        isLetterSection: false,
        isLoiSection: false,
        index: 3,
        isAvailableForBuyers: true,
        isAvailableForSellers: true,
        isArchive: false,
    },
    {
        id: generateGuid(),
        name: 'PIP(s)',
        isLetterSection: false,
        isLoiSection: false,
        index: 4,
        isAvailableForBuyers: true,
        isAvailableForSellers: true,
        isArchive: false,
    },
    {
        id: generateGuid(),
        name: 'DFM(s)',
        isLetterSection: false,
        isLoiSection: false,
        index: 5,
        isAvailableForBuyers: true,
        isAvailableForSellers: true,
        isArchive: false,
    },
    {
        id: generateGuid(),
        name: 'Seller Obligation Contracts',
        isLetterSection: false,
        isLoiSection: false,
        index: 6,
        isAvailableForBuyers: true,
        isAvailableForSellers: true,
        isArchive: false,
    },
    {
        id: generateGuid(),
        name: 'LOI Submission Packages',
        isLetterSection: false,
        isLoiSection: true,
        index: 7,
        isAvailableForBuyers: true,
        isAvailableForSellers: true,
        isArchive: false,
    },
    {
        id: generateGuid(),
        name: 'Due Diligence NDA',
        isLetterSection: false,
        isLoiSection: false,
        index: 8,
        isAvailableForBuyers: true,
        isAvailableForSellers: true,
        isArchive: false,
    },
];
